export default "__VITE_ASSET__CVXr3R1N__"